function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h80v80H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  d: "M3.006 20.622v4.946l36.201 10.69 36.636-10.69V22.84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.907 20.941l.879-1.338c.157-.025 11.667-2.517 34.529-7.478l35.891 8.492 1.644.974v1.306",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.813 17.21l-31.821 9.638c-.659.18-1.104.406-1.335.677-.23.272-.396.763-.495 1.473v40.487l-6.495-1.86V27.038c.102-.688.272-1.29.507-1.803.236-.514 1.02-.953 2.35-1.319l31.273-8.25 6.016 1.543z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.34 17.098l31.82 9.638c.659.18 1.104.406 1.335.678.231.271.396.762.495 1.472v40.487l6.656-2.24V26.548c-.102-.688-.272-1.29-.507-1.803-.236-.513-1.02-.953-2.35-1.319l-31.272-8.25-6.177 1.922z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.204 26.385v37.708l33.95 9.78 33.97-9.78V26.385l-33.96 9.783-33.96-9.783z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.796 20.63c.178-2.675 1.178-5.6 3.001-8.772 1.823-3.173 3.687-5.237 5.595-6.191 12.311 6.506 18.916 10.643 19.814 12.411.897 1.769 1.1 2.596.606 2.482-.796 1.002-1.221 1.499-1.277 1.49-5.47-.803-9.8-1.067-12.989-1.26-3.238-.195-8.155-.248-14.75-.16z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.967 20.63c-.178-2.675-1.178-5.6-3-8.772-1.823-3.173-3.688-5.237-5.595-6.191C46.06 12.173 39.456 16.31 38.558 18.078c-.898 1.769-.866 2.835.095 3.198.328.525.52.783.576.774 5.47-.803 9.8-1.067 12.989-1.26 3.238-.195 8.155-.248 14.75-.16z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.957 22l-1.716-5.25c.93-.38 2.452-.562 4.564-.545 2.112.016 3.526.22 4.24.613l-1.924 5.183c-.408.32-1.192.48-2.35.48-1.158 0-2.096-.16-2.814-.48z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.333 73.393V41.016v32.377z",
  stroke: "#371447"
}));

function SvgOccasionsLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgOccasionsLg;